// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c7ff834e","453":"bdba1d6e","732":"85cfb928","977":"d9026cb9"}[chunkId] + ".chunk.js";
};